<!-- foto_url -->
<template>
  <PainelLayout>
    <Breadcrumb :lista="[
      { 'name':'Painel', 'link' : '/' },
      { 'name':'Estoque', 'link' : '/stock' }]"
    />

    <h1 class="text-center" v-if="operation === 'store'">Novo Item</h1>
    <h1 class="text-center" v-if="operation === 'update'">Atualizar Item</h1>
    <!-- Div Formulario -->
    <form class="row" v-if="!loading" @submit.prevent="actionOperation" @keydown.enter.prevent>
      <div class="col-2"></div>
      <div class="col-12 col-md-8" >
        <div v-if="errors.length > 0" class="alert alert-danger mb-3" role="alert">
          <ul class="mb-0">
            <li v-for="error in errors" :key="error">{{ error }}</li>
          </ul>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="inpFile">Foto:</label>
              <input @change="onFileChange" type="file" class="form-control" name="inpFile" id="inpFile" placeholder="Digite o nome da categoria">
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-6">
              <div class="form-group">
                <label for="txtName">Nome:</label>
                <input @change="setLink()" v-model="item.name" required type="text" class="form-control" name="txtName" id="txtName" placeholder="Digite o nome da categoria">
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label for="txtCode">Codigo:</label>
                <input v-model="item.code" required type="text" class="form-control" name="txtCode" id="txtCode" placeholder="Digite o codigo de referencia">
              </div>
            </div>
          </div>
          <div class="col-12 mt-3">
            <div class="form-group">
              <label for="txtLink">Link</label>
              <input :style="!linkPersonalized ? 'background-color: #d1d1d1; color: gray;' : ''" :readonly="!linkPersonalized" v-model="item.link" required type="text" class="form-control" name="txtLink" id="txtLink">
              <label class="form-text mt-2" for="customLinkCheckbox">Link Personalizado?</label>
              <input type="checkbox" v-model="linkPersonalized" id="customLinkCheckbox" value="false">
            </div>
          </div>
          <div class="col-12 mt-3">
            <div class="form-group">
              <label for="itemDescription">Descrição</label>
              <input name="itemDescription" id="itemDescription" v-model="item.description" type="text" class="form-control" placeholder="Digite a descrição da categoria">
            </div>
          </div>
          <div class="row mt-3">
            <div class="col">
              <label for="selCategori">Categoria</label>
              <select name="selCategori" id="selCategori" v-model="item.id_category" required class="form-select" aria-label="Default select example">
                <option disabled selected>Selecione a categoria</option>
                <option v-for="item in lista_categories" :key="item.id" :value="item.id">{{ item.name }}</option>
              </select>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-6">
              <div class="form-group">
                <label for="txtValor">Valor:</label>
                <input v-model="item.unit_price" required type="number" step="0.01" class="form-control" name="txtValor" id="txtValor" placeholder="Digite o valor da locação">
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label for="txtQuant">Quantidade em estoque:</label>
                <input v-model="item.quant" required type="number" class="form-control" name="txtQuant" id="txtQuant" placeholder="Digite a quantidade desse item em estoque">
              </div>
            </div>
          </div>
        </div>
      <div class="col-2"></div>
      </div>
      <!-- Div Botão Salvar -->
      <div class="row mt-4 text-center">
        <div class="col-12">
          <router-link class="btn btn-secondary me-2" to="/stock">
            Voltar
          </router-link>
          <button @click="actionOperation" class="btn btn-primary me-2">
            <span>{{ operation === 'store' ? 'Salvar' : 'Atualizar' }}</span>
          </button>
          <button @click="clearForm" class="btn btn-secondary me-2">
            Limpar
          </button>
        </div>
      </div>
    </form>
    <!-- Div Loading -->
    <div v-else class="d-flex justify-content-center p-3 text-center">
      <div>
        <div class="spinner-border" style="width: 7rem; height: 7rem;" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <p class="mt-2" v-if="operation === 'update' && loading">Carregando dados do item...</p>
        <p class="mt-2" v-else-if="loading">Salvando item...</p>
      </div>
    </div>
  </PainelLayout>
</template>

<script>
import PainelLayout from '@/layouts/PainelLayout.vue';
import { onMounted, reactive, ref } from 'vue';
import { categories } from '@/models/categories';
import { itens } from '@/models/itens';
import Breadcrumb from '@/components/itens/breadcrumb.vue';
import { useToastStore } from '@/stores/toastStore';
import { parseError } from '@/utils/errorHelper';
import router from '@/router';

export default {
  name: "NewCategoryView",
  components: { PainelLayout, Breadcrumb },
  setup(props) {

    const toastStore = useToastStore();
    var loading = ref(false);
    var operation = ref('store');
    const model = itens();
    const lista_categories = ref([]);
    const Categories = categories();

    var errors = ref([]);

    const linkPersonalized = ref(false);

    const item = reactive({
      id: null,
      name: '',
      description: '',
      link: '',
      foto_url: null,
      code: '',
      unit_price: null,
      id_category: null,
      quant: null
    });

    function onFileChange(event) {
      item.foto_url = event.target.files[0];
    }

    const setLink = () => {
      item.link = item.name.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, '');
    };

    const validate = () => {
      errors.value = [];
      if (!item.name) errors.value.push("O nome do item é obrigatório.");
      if (!item.code) errors.value.push("O código de referência é obrigatório.");
      if (!item.id_category) errors.value.push("Selecione uma categoria.");
      if (item.unit_price === null || item.unit_price === undefined) errors.value.push("O valor da locação é obrigatório.");
      if (item.quant === null || item.quant === undefined) errors.value.push("A quantidade em estoque é obrigatória.");
      
      return errors.value.length === 0;
    };

    const actionOperation = () => {
      if (!validate()) {
        toastStore.warning('Por favor, corrija os erros no formulário.');
        return;
      }
      if (operation.value === 'update') {
        update();
      } else {
        store();
      }
    }

    function store() {
      loading.value = true;
      const form = new FormData();
      // ... (rest of form appending remains same as it was)
      form.append('id', item.id);
      form.append('name', item.name);
      form.append('description', item.description);
      form.append('link', item.link);
      form.append('code', item.code);
      form.append('unit_price', item.unit_price);
      form.append('id_category', item.id_category);
      form.append('quant', item.quant);

      if (item.foto_url) {
          form.append('foto_url', item.foto_url);
      }

      model.store(form).then((data) => {
        toastStore.success('Item criado com sucesso!');
        loading.value = false;
        router.push('/stock');
      }).catch((error) => {
        loading.value = false;
        toastStore.error('Erro ao criar item: ' + parseError(error));
      });
    }

    function update() {
      loading.value = true;
      model.update(item).then(() => {
        toastStore.success('Item atualizado com sucesso!');
        loading.value = false;
        router.push('/stock');
      }).catch((error) => {
        toastStore.error('Erro ao atualizar item: ' + parseError(error));
        loading.value = false;
      });
    }

    async function loadCategories() {
      lista_categories.value = await Categories.list();
    }

    onMounted(() => {
      loadCategories();

      const query = window.location.search;
      const urlParams = new URLSearchParams(query);
      const edit = urlParams.get('edit');
      const id = urlParams.get('id');

      if (edit && id) {
        document.title = "Atualizar Item - Ideal Festas";

        operation.value = 'update';
        loading.value = true;
        model.getOne(id).then((response) => {
          item.id = response.id;
          item.name = response.name;
          item.description = response.description;
          item.link = response.link;
          item.code = response.code;
          item.unit_price = response.unit_price;
          item.id_category = response.id_category;
          item.quant = response.quant;
          loading.value = false;
        }).catch((error) => {
          toastStore.error('Erro ao carregar dados do item: ' + parseError(error));
          loading.value = false;
        });
      }
    });

    return {
      item,
      onFileChange,
      linkPersonalized,
      setLink,
      actionOperation,
      operation,
      loading,
      lista_categories,
      errors
    }

  }
}
</script>